<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Usage Report</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <div class="divider"></div>
    <div class="tests-toggle">
      <mat-slide-toggle
        color="lightGreen"
        [checked]="includeTests"
        (change)="onIncludeTestsToggle($event.checked)"
      >
        Include tests
      </mat-slide-toggle>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <ng-container *ngIf="usageData.length">
      <button
        mat-icon-button
        [matMenuTriggerFor]="exportMenu"
        matTooltip="Export Data"
        aria-label="Export Data"
        style="margin-right: 8px;"
      >
        <svg-icon src="assets/svg/download.svg"></svg-icon>
      </button>
      <mat-menu class="mat-menu-elaphant" #exportMenu="matMenu">
        <button class="icon-btn-w-text" mat-menu-item (click)="exportToExcel()">
          <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
          <span>Export to Excel</span>
        </button>
        <button class="icon-btn-w-text" mat-menu-item (click)="exportToCsv()">
          <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
          <span>Export to CSV</span>
        </button>
      </mat-menu>
    </ng-container>
    <button 
      *ngIf="getTotalFeedback() > 0"
      mat-button 
      class="feedback-button"
      (click)="navigateToFeedback()"
      title="View Feedback for this date range">
      <span>View Feedback</span>
    </button>
  </div>
</div>

<div class="usage-report">
  <div class="container usage-container">
    <div class="summary-stats" *ngIf="usageData.length">
      <div class="stat-card">
        <div class="stat-value">{{ getTotalThreads() | number }}</div>
        <div class="stat-label">Total Threads</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalResults() | number }}</div>
        <div class="stat-label">Total Results</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalAnonymousThreads() | number }}</div>
        <div class="stat-label">Anonymous</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalNonAnonymousThreads() | number }}</div>
        <div class="stat-label">Non-Anonymous</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalUniqueDevices() | number }}</div>
        <div class="stat-label">Unique Devices</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalUniqueUsers() | number }}</div>
        <div class="stat-label">Unique Users</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalShares() | number }}</div>
        <div class="stat-label">Total Shares</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalRatings() | number }}</div>
        <div class="stat-label">Total Ratings</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalFeedback() | number }}</div>
        <div class="stat-label">Total Feedback</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getAverageRating() | number:'1.1-1' }}</div>
        <div class="stat-label">Average Rating</div>
      </div>
    </div>

    <div class="summary-stats bookings-summary-stats" *ngIf="usageData.length && isAura">
      <div class="stat-card" *ngIf="isAura">
        <div class="stat-value">{{ getTotalBookingsCreated() | number }}</div>
        <div class="stat-label">Bookings Created</div>
      </div>
      <div class="stat-card" *ngIf="isAura">
        <div class="stat-value">{{ getTotalBookingsUpdated() | number }}</div>
        <div class="stat-label">Bookings Updated</div>
      </div>
      <div class="stat-card" *ngIf="isAura">
        <div class="stat-value">{{ getTotalBookingsCancelled() | number }}</div>
        <div class="stat-label">Bookings Cancelled</div>
      </div>
    </div>

    <div class="top-results" *ngIf="topCategories.length">
      <div class="top-results-header">Top Categories</div>
      <div class="top-results-body">
        <div class="categories-list">
          <button
            type="button"
            class="category-item"
            *ngFor="let category of topCategories"
            [class.selected]="category.category_id === selectedCategoryId"
            (click)="selectCategory(category.category_id)"
          >
            <span class="category-name">{{ category.category_name }}</span>
            <span class="category-count">{{ category.returned_count | number }}</span>
          </button>
        </div>

        <div class="documents-panel" *ngIf="selectedCategoryId !== null">
          <div class="documents-header">Top {{ documentsLabelPlural }}</div>
          <div class="documents-list">
            <div class="document-item" *ngFor="let doc of getSelectedCategoryDocuments()">
              <div class="document-text">
                <div class="document-name">{{ doc.name }}</div>
                <div class="document-subtitle" *ngIf="doc.subtitle">{{ doc.subtitle }}</div>
              </div>
              <div class="document-count">{{ doc.returned_count | number }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-content">
      <mat-table 
        #usageTable 
        [dataSource]="usageDataSource" 
        matSort 
        class="usage-table">
        
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ formatDate(row.date) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="results_count">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Results</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.results_count | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="threads">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Threads</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.threads | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="anonymous_threads">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Anonymous</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.anonymous_threads | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="non_anonymous_threads">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Non-Anonymous</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.non_anonymous_threads | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="unique_devices">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Unique Devices</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.unique_devices | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="unique_users">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Unique Users</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.unique_users | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="total_shares">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Shares</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.total_shares | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="total_ratings">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Ratings</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.total_ratings | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="total_feedback">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Feedback</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.total_feedback | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="average_rating">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Avg Rating</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.average_rating | number:'1.1-1' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bookings_created">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Bookings Created</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.bookings_created | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bookings_updated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Bookings Updated</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.bookings_updated | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bookings_cancelled">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Bookings Cancelled</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.bookings_cancelled | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="availability_checks">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Availability Checks</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.availability_checks | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bookings_queries">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Booking Queries</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.bookings_queries | number }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <mat-paginator 
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="perPage"
        showFirstLastButtons
        (page)="onPageChange($event)">
      </mat-paginator>

      <div class="no-data" *ngIf="!usageData.length">
        <p>No usage data found for the selected date range.</p>
      </div>
    </div>
  </div>
</div> 